const MONTH_MAP = {
  jan: 'January',
  feb: 'February',
  mar: 'March',
  apr: 'April',
  may: 'May',
  jun: 'June',
  jul: 'July',
  aug: 'August',
  sep: 'September',
  oct: 'October',
  nov: 'November',
  dec: 'December'
};

export const generateDynamicMonthColumns = (keys) => {
  return keys
    .filter((key) => /^[a-z]{3}month_datausage_mb$/.test(key))
    .map((key) => {
      const monthAbbrev = key.slice(0, 3); // 'apr', 'may', etc.
      const monthName = MONTH_MAP[monthAbbrev.toLowerCase()] || monthAbbrev;

      //   const currentYear = new Date().getFullYear();
      const label = `${monthName} Data Usage (MB)`;

      return {
        name: key,
        label,
        options: { display: false }
      };
    });
};
